import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import '../assets/css/categoryList.css';

import Breadcrumb from '../Component/Layout/Breadcrumb';
import SearchFilter from '../Component/Layout/Searchlist';
import MobileFilter from '../Component/Layout/MobileFilter/MobileFilter';
import FilterDesktop from '../Component/Layout/Filter/FilterDesktop';
import ProductShorting from '../Component/Common/ProductShorting';

import p1 from '../../src/assets/images/img/b-1.webp';
import p2 from '../../src/assets/images/img/b-2.webp';
import p3 from '../../src/assets/images/img/b-3.webp';
import p4 from '../../src/assets/images/img/b-4.webp';
import p5 from '../../src/assets/images/img/b-5.webp';
import p6 from '../../src/assets/images/img/b-6.webp';

const imageList = [p1, p2, p3, p4, p5, p6];

const Bathlines = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      const fetchedProducts = imageList.map((img, index) => ({
        id: index,
        name: 'Bath Linen',
        image: img
      }));
      setProducts(fetchedProducts);
      setLoading(false);
    }, 2000);
  }, []);

  const handleWishlistClick = (id) => {
    console.log(`Add to wishlist: ${id}`);
  };

  return (
    <>
      <Breadcrumb />
      <section className="category-List">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-6 col-12">
              <div className="row">
                <div className="col-md-3 col-4 col-md-minwidth col-md-minwidth-ss001">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className="FILTER-MOBILE">
                      <MobileFilter />
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-5 text-end">
                  <p style={{
                    textAlign: 'left',
                    color: 'rgb(127 127 127)',
                    marginBottom: 0,
                    marginTop: "2px",
                    fontSize: "14px"
                  }}>
                    Showing {products.length} items
                  </p>
                </div>

                <div className="col-md-5 col-5 col-md-news-right001">
                  <div className='d-Fles-Rto' style={{ justifyContent: "flex-end" }}>
                    <SearchFilter />
                    <ProductShorting />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className='col-md-3 col-md-minwidth col-md-minwidth-ss'>
                  <FilterDesktop />
                </div>

                <div className='col-md-9 col-md-minwidth-left'>
                  <div className='row'>
                    {loading
                      ? Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className="col-lg-3 col-md-3 col-sm-6 col-6">
                          <div className="border-1 p-0 mt-1">
                            <Skeleton height={200} style={{ borderRadius: '2px' }} />
                            <div className="text-center mt-1">
                              <Skeleton width={`80%`} />
                            </div>
                          </div>
                        </div>
                      ))
                      : products.map((product) => (
                        <div key={product.id} className="col-lg-3 col-md-3 col-sm-6 col-6">
                          <div className="latest-items latest-items2">
                            <div className="properties">
                              <div className="properties-card">
                                <div className="properties-img">
                                  <Link to="/ProductDetails" target='_blank'>
                                    <img src={product.image} alt={product.name} style={{ borderRadius: '2px' }} />
                                  </Link>
                                  <span className="like-heart">
                                    <button
                                      onClick={() => handleWishlistClick(product.id)}
                                      className="wishlist-btn"
                                      style={{ background: 'none', border: 'none', padding: 0 }}
                                    >
                                      <i className="fa fa-heart-o" />
                                    </button>
                                  </span>
                                </div>
                                <div className="properties-caption properties-caption2">
                                  <h3>
                                    <Link to="/ProductDetails" target="_blank">
                                      {product.name}
                                    </Link>
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Bathlines;
